module.exports = __webpack_public_path__ + "img/97a19842-db31-4537-9241-5053d7c96239.3356499c.jpg";